import React from 'react'

export default function Calling() {
    return (
        <div>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.6257 7.33815C9.13688 8.07738 7.99997 9.13887 7.99997 10C7.99997 10.9972 9.06261 13.0054 10.4427 14.3684C11.8227 15.7315 12.9903 16.5 14 16.5C14.6874 16.5 15.0328 14.8421 16.8689 14.8421C18.2459 14.8421 20 16.3421 20.5 18C20.7867 18.9506 19.6639 19.8088 18.4048 20.4062C17.4177 20.8747 16.311 21.0432 15.2234 20.9385C13.2369 20.7474 10.4046 19.9623 6.99998 16.7368C3.09846 12.5 2.90148 9.72438 2.99997 7.01385C3.09847 4.30332 5.49998 3 6.31156 3C7.06449 3 9.42441 5.03844 9.7616 6.64692C9.81183 6.88649 9.76071 7.13397 9.6257 7.33815Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M14 6.00502C14 6.00502 15.7671 5.76212 17.2914 7.28636C18.8156 8.8106 18.5727 10.5777 18.5727 10.5777" stroke="white" stroke-width="2" stroke-linecap="round" />
                <path d="M13.9999 2.00495C13.9999 2.00495 16.8364 1.83637 19.4999 4.49994C22.1635 7.16351 21.9906 9.99566 21.9906 9.99566" stroke="white" stroke-width="2" stroke-linecap="round" />
            </svg>

        </div>
    )
}
